import { yup } from '@framework/validation/initYup.ts';
import { CommonBaseWidgetSchema } from '../../../CommonBaseWidgetSchema.ts';
import { uniqueWidgetCodeSchema } from '../../../validation/uniqueWidgetCodeSchema.ts';
import { WidgetType } from '../../../Widget.ts';
import { IconType } from '../buttons/icons/Icons.tsx';
import { ButtonAlign, ButtonType } from '../buttons/types/ButtonEnums.ts';
import { type IConfirmWidget } from './IConfirmWidget.ts';

export const ConfirmWidgetSchema = CommonBaseWidgetSchema.shape({
  code: uniqueWidgetCodeSchema,
  type: yup.string().required().exact(WidgetType.Confirm).label('Tipo'),
  layout: yup.object({
    confirmIcon: yup
      .string()
      .oneOfEnum(IconType)
      .default(IconType.Nessuna)
      .optional()
      .label('Icona pulsante di conferma'),
    confirmText: yup.string().default('Conferma'),
    confirmButtonType: yup
      .string()
      .oneOfEnum(ButtonType)
      .default(ButtonType.Primary)
      .optional()
      .label('Tipo pulsante di conferma'),

    editIcon: yup
      .string()
      .oneOfEnum(IconType)
      .default(IconType.Nessuna)
      .optional()
      .label('Icona pulsante di modifica'),
    editText: yup.string().default('Modifica'),
    editButtonType: yup
      .string()
      .oneOfEnum(ButtonType)
      .default(ButtonType.Primary)
      .optional()
      .label('Tipo pulsante di modifica'),
    alignEnd: yup.boolean().default(false),

    buttonsAlign: yup
      .string()
      .oneOfEnum(ButtonAlign)
      .default(ButtonAlign.End)
      .optional()
      .label('Allineamento pulsante'),
  }),
})
  .required()
  .noUnknown() satisfies yup.ObjectSchema<IConfirmWidget>;
